import { Phone, Instagram, MessageCircle } from "lucide-react";
import { Reveal } from "./Reveal";

export const Contact = () => (
  <section id="contact" className="py-16 lg:py-24 px-4 sm:px-6 lg:px-10 bg-[#FAFAF8]" data-testid="contact-section">
    <div className="max-w-7xl mx-auto bg-[#0E0E0E] rounded-3xl p-8 sm:p-12 lg:p-16 text-white">
      <Reveal>
        <span className="font-heading text-xs sm:text-sm font-bold tracking-[0.25em] uppercase text-[#E7CE96]">Contact</span>
        <h2 className="font-heading font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-5 leading-[1.05]">
          Your <em className="font-bold text-[#E7CE96]">transformation</em> starts here.
        </h2>
        <p className="mt-6 max-w-xl text-lg text-white/75 leading-relaxed">
          Ready to elevate your clinical practice? Reach out to enquire about any course,
          batch dates or the internship program.
        </p>
      </Reveal>

      <Reveal delay={0.2} className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5">
        <a
          href="tel:+919321967864"
          data-testid="contact-phone-link"
          className="group bg-white/[0.06] rounded-2xl p-7 lg:p-9 hover:bg-white/[0.12] transition-colors duration-300"
        >
          <span className="inline-flex w-11 h-11 rounded-xl bg-[#C6A45C] items-center justify-center">
            <Phone size={18} className="text-white" />
          </span>
          <p className="mt-5 font-heading text-xs font-bold tracking-[0.15em] uppercase text-white/50">Call / Mobile</p>
          <p className="mt-1.5 font-heading font-bold text-xl lg:text-2xl group-hover:text-[#E7CE96] transition-colors duration-300">
            +91 93219 67864
          </p>
        </a>
        <a
          href="https://wa.me/919321967864"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="contact-whatsapp-link"
          className="group bg-white/[0.06] rounded-2xl p-7 lg:p-9 hover:bg-white/[0.12] transition-colors duration-300"
        >
          <span className="inline-flex w-11 h-11 rounded-xl bg-[#C6A45C] items-center justify-center">
            <MessageCircle size={18} className="text-white" />
          </span>
          <p className="mt-5 font-heading text-xs font-bold tracking-[0.15em] uppercase text-white/50">WhatsApp</p>
          <p className="mt-1.5 font-heading font-bold text-xl lg:text-2xl group-hover:text-[#E7CE96] transition-colors duration-300">
            Message Directly
          </p>
        </a>
        <a
          href="https://instagram.com/drkshamamentors"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="contact-instagram-link"
          className="group bg-white/[0.06] rounded-2xl p-7 lg:p-9 hover:bg-white/[0.12] transition-colors duration-300"
        >
          <span className="inline-flex w-11 h-11 rounded-xl bg-[#C6A45C] items-center justify-center">
            <Instagram size={18} className="text-white" />
          </span>
          <p className="mt-5 font-heading text-xs font-bold tracking-[0.15em] uppercase text-white/50">Instagram</p>
          <p className="mt-1.5 font-heading font-bold text-xl lg:text-2xl group-hover:text-[#E7CE96] transition-colors duration-300">
            @drkshamamentors
          </p>
        </a>
      </Reveal>

      <div className="mt-14 pt-7 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <p className="font-heading text-xs font-medium tracking-[0.12em] uppercase text-white/40" data-testid="footer-copyright">
          © {new Date().getFullYear()} Dr. Kshama Chandan · Mentors
        </p>
        <p className="font-heading text-xs font-medium tracking-[0.12em] uppercase text-white/40">
          @drkshamamentors
        </p>
      </div>
    </div>
  </section>
);
